/**
 * 订单详情抽屉 - 备注提醒区块
 *
 * 展示当日到期的备注提醒列表（逾期/今日到期标记），支持单条忽略与全部忽略。
 * 受控组件，不持有业务状态。
 */
import type { OrderReminder } from '../types';

interface Props {
  reminders: OrderReminder[];
  today: string;
  onDismiss: (id: string) => void;
  onDismissAll: () => void;
}

export default function RemindersSection({ reminders, today, onDismiss, onDismissAll }: Props) {
  return (
    <>
      {/* Reminders */}
      {reminders.length > 0 && (
        <div className="bg-amber-50 border border-amber-200 rounded-xl overflow-hidden">
          <div className="flex items-center gap-2 px-3.5 py-2.5 bg-amber-100/60 border-b border-amber-200">
            <div className="w-5 h-5 flex items-center justify-center shrink-0"><i className="ri-alarm-warning-line text-amber-500 text-sm" /></div>
            <p className="text-xs font-semibold text-amber-700 flex-1">备注提醒<span className="ml-1.5 font-normal text-amber-500">{reminders.length} 条到期</span></p>
            <button onClick={onDismissAll} className="text-xs text-amber-400 hover:text-amber-600 cursor-pointer transition-colors whitespace-nowrap">全部忽略</button>
          </div>
          <div className="divide-y divide-amber-100">
            {reminders.map(r => {
              const isOverdue = r.remindAt < today;
              return (
                <div key={r.id} className="flex items-start gap-2.5 px-3.5 py-2.5">
                  <div className={`w-1.5 h-1.5 rounded-full mt-1.5 shrink-0 ${isOverdue ? 'bg-rose-400' : 'bg-amber-400'}`} />
                  <div className="flex-1 min-w-0">
                    <span className={`inline-flex items-center gap-0.5 text-[10px] font-semibold px-1.5 py-0.5 rounded-full mb-1 ${isOverdue ? 'bg-rose-100 text-rose-500' : 'bg-amber-100 text-amber-600'}`}>
                      <i className="ri-alarm-line text-[10px]" />
                      {isOverdue ? '逾期 ' + r.remindAt.slice(5) : '今日到期 ' + r.remindAt.slice(5)}
                    </span>
                    <p className="text-xs text-gray-700 leading-relaxed line-clamp-2">{r.content}</p>
                  </div>
                  <button onClick={() => onDismiss(r.id)} className="w-5 h-5 flex items-center justify-center text-amber-300 hover:text-amber-500 cursor-pointer transition-colors shrink-0 mt-0.5">
                    <i className="ri-close-line text-sm" />
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
}